export default __webpack_public_path__ + "static/media/email.85bec5ee.svg";